"use strict";
"use client";
'use strict';

var React = require('react');
var createIcon = require('@ux/icon/base.js');

const Icon = ({
  name,
  ...props
}) => {
  const loadAttempted = React.useRef(false);
  const retryCount = React.useRef(0);
  const tryLoadSymbol = React.useCallback(() => {
    if (window.__iconRegistry) {
      if (!window.__iconRegistry.hasSymbol(name)) {
        window.__iconRegistry.loadSymbol(name);
      }
      loadAttempted.current = true;
    } else {
      const backoffDelay = Math.min(100 * Math.pow(2, retryCount.current), 5e3);
      retryCount.current += 1;
      setTimeout(tryLoadSymbol, backoffDelay);
    }
  }, [name]);
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    tryLoadSymbol();
    return () => {
      retryCount.current = 0;
    };
  }, [tryLoadSymbol]);
  const IconComponent = React.useMemo(
    () => (
      // @ts-expect-error types are wrong
      createIcon(name, false)
    ),
    [name]
  );
  return /* @__PURE__ */ React.createElement(IconComponent, { ...props });
};

exports.Icon = Icon;
//# sourceMappingURL=icon.cjs.map
